<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>          
        <v-row>   
            <v-col cols="9">
                <div class="text-left">
                    <p>Breakfast Fruit Platter $20 + $1.68 Tax + $5 tip</p>
                    <img alt="Breakfast Fruit Platter" class="uitk-image-media" src="/vegasjan/28breakfast.jpg" style="width: 17%; height: auto;">     
                </div>
                <div class="text-left" style="margin-top:20px;">
                    <b>Lunch</b>
                    <p>Mega Sandwich $8.50</p>
                    <p>Coke Zero     $3.49</p>
                    <p>Ruffles       $2.69</p>
                    <p>M&M Minis     $3.29</p>
                    <p>Total        $16.26 ($26.08AUD)</p>
                    <img alt="Lunch" class="uitk-image-media" src="/vegasjan/28Lunch.jpg" style="width: 17%; height: auto;">                
                </div>        
                <div class="text-left" style="margin-top:20px;">
                    <b>Dinner</b>
                    <p>Salad and fish and chips (but without the chips) + 2 ciders that were included in my 4 drinks for the day</p>
                    <p>$53.98 + $4.52 tax + $15 tip</p>
                    <img alt="Dinner" class="uitk-image-media" src="/vegasjan/28Dinner.jpeg" style="width: 17%; height: auto;">                
                </div>  
                <div class="text-left" style="margin-top:20px;">
                    <b>Mega Jackpot 25 cent machine</b>
                    <p>$1709.69 becomes just over $1100 after tax but remember whatever you win in Vegas stays in Vegas</p>
                    <img alt="1100" class="uitk-image-media" src="/vegasjan/1100.jpeg" style="width: 17%; height: auto;">                
                </div>                                             
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Some gambling and drinking occurred among other things.</p>
                </div>  
                <div class="text-left">
                    <p>Stock market open most things up ... good day to hold.</p>
                </div>
            </v-col>               
        </v-row>
    </v-container>
  </template>